import { render } from "./RealtimeSuccessful.vue?vue&type=template&id=2f82b265&scoped=true"
import script from "./RealtimeSuccessful.vue?vue&type=script&lang=js"
export * from "./RealtimeSuccessful.vue?vue&type=script&lang=js"

import "./RealtimeSuccessful.vue?vue&type=style&index=0&id=2f82b265&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f82b265"]])

export default __exports__